//Limitless imports
import { handleSecureAjaxError } from "../utils/SecurePlatformAPIUtils";
import { getGraphQLClient } from "../clients/GraphQLClient";
export const GET_PENDING_QUESTIONS_HISTORY = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "getPendingMessages"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "messageId"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "groupName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "tenantName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "contributorsCount"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "lifecycleState"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "fee"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "expectedPaymentDate"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "type"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 241,
    "source": {
      "body": "\n    {\n        getPendingMessages {\n            messageId\n            groupName\n            tenantName\n            contributorsCount\n            lifecycleState\n            fee\n            expectedPaymentDate\n            type\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export const fetchPendingQuestions = callback => {
  const graphQLClient = getGraphQLClient();
  graphQLClient.query({
    query: GET_PENDING_QUESTIONS_HISTORY,
    fetchPolicy: "no-cache"
  }).then(response => {
    const records = response.data.getPendingMessages;
    if (records) {
      callback(records);
    } else {
      callback([]);
    }
  }).catch(error => {
    handleSecureAjaxError(error, "PendingQuestionsHistoryActions fetchPendingQuestions");
    callback({
      hasError: true,
      error
    });
  });
};